export const fieldPositionLabels = [
  { hasNotch: true, label: '0', position: 0 },
  {
    hasNotch: true,
    label: '10',
    position: 10,
  },
  {
    hasNotch: true,
    label: '20',
    position: 20,
  },
  {
    hasNotch: true,
    label: '30',
    position: 30,
  },
  {
    hasNotch: true,
    label: '40',
    position: 40,
  },
  {
    hasNotch: true,
    label: '50',
    position: 50,
  },
  {
    hasNotch: true,
    label: '40',
    position: 60,
  },
  {
    hasNotch: true,
    label: '30',
    position: 70,
  },
  {
    hasNotch: true,
    label: '20',
    position: 80,
  },
  {
    hasNotch: true,
    label: '10',
    position: 90,
  },
  {
    hasNotch: true,
    label: '0',
    position: 100,
  },
];
